import { useState } from 'react';
import Layout from '../../../components/feature/Layout';

interface RiskOperation {
  id: string;
  correlativo: string;
  cliente: string;
  tipo: string;
  riesgo: string;
  motivo: string;
  responsable: string;
  tiempoVencido: string;
  estado: string;
  prioridad: 'alta' | 'urgente' | 'critica';
}

export default function OperationsRisk() {
  const [selectedFilter, setSelectedFilter] = useState('todos');
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedOp, setSelectedOp] = useState<RiskOperation | null>(null);

  const riskOperations: RiskOperation[] = [
    {
      id: '1',
      correlativo: 'OP-2024-1823',
      cliente: 'Importadora Global S.A.',
      tipo: 'Importación',
      riesgo: 'Documentos Faltantes',
      motivo: 'Certificado de Origen pendiente',
      responsable: 'María González',
      tiempoVencido: '2 días',
      estado: 'En Aduana',
      prioridad: 'critica'
    },
    {
      id: '2',
      correlativo: 'OP-2024-1815',
      cliente: 'Exportadora del Sur Ltda.',
      tipo: 'Exportación',
      riesgo: 'Por Vencer',
      motivo: 'ETA en 24 horas, documentación incompleta',
      responsable: 'Carlos Ramírez',
      tiempoVencido: '1 día',
      estado: 'Documentación',
      prioridad: 'urgente'
    },
    {
      id: '3',
      correlativo: 'OP-2024-1808',
      cliente: 'Comercial Andina S.A.C.',
      tipo: 'Importación',
      riesgo: 'Sin Movimiento',
      motivo: 'Sin actualizaciones hace 72 horas',
      responsable: 'Ana Torres',
      tiempoVencido: '3 días',
      estado: 'En Tránsito',
      prioridad: 'alta'
    },
    {
      id: '4',
      correlativo: 'OP-2024-1801',
      cliente: 'Distribuidora Pacífico E.I.R.L.',
      tipo: 'Importación',
      riesgo: 'Vencida',
      motivo: 'Fecha de entrega superada',
      responsable: 'Luis Mendoza',
      tiempoVencido: '5 días',
      estado: 'Despacho',
      prioridad: 'critica'
    },
    {
      id: '5',
      correlativo: 'OP-2024-1795',
      cliente: 'Logística Internacional Corp.',
      tipo: 'Tránsito',
      riesgo: 'Documentos Faltantes',
      motivo: 'Manifiesto de carga sin validar',
      responsable: 'María González',
      tiempoVencido: '1 día',
      estado: 'Revisión',
      prioridad: 'urgente'
    },
    {
      id: '6',
      correlativo: 'OP-2024-1788',
      cliente: 'Importadora Global S.A.',
      tipo: 'Importación',
      riesgo: 'Por Vencer',
      motivo: 'Almacenaje vence en 48 horas',
      responsable: 'Carlos Ramírez',
      tiempoVencido: '2 días',
      estado: 'En Aduana',
      prioridad: 'alta'
    }
  ];

  const getPriorityColor = (prioridad: string) => {
    switch (prioridad) {
      case 'critica': return 'bg-[#EF4444] text-white';
      case 'urgente': return 'bg-[#F59E0B] text-white';
      case 'alta': return 'bg-[#EAB308] text-white';
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  const getRiskIcon = (riesgo: string) => {
    switch (riesgo) {
      case 'Documentos Faltantes': return 'ri-file-warning-line';
      case 'Por Vencer': return 'ri-time-line';
      case 'Vencida': return 'ri-error-warning-line';
      case 'Sin Movimiento': return 'ri-pause-circle-line';
      default: return 'ri-alert-line';
    }
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#0A2A43]">Operaciones en Riesgo</h1>
            <p className="text-sm text-[#6B7280] mt-1">Monitoreo de operaciones críticas que requieren atención inmediata</p>
          </div>
          <div className="flex items-center gap-3">
            <button className="px-4 py-2.5 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
              <i className="ri-download-line mr-2"></i>Exportar
            </button>
            <button className="px-4 py-2.5 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap">
              <i className="ri-notification-line mr-2"></i>Notificar Equipo
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-4 gap-4">
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-[#6B7280]">Total en Riesgo</span>
              <div className="w-8 h-8 rounded-lg bg-[#EF4444]/10 flex items-center justify-center">
                <i className="ri-alert-line text-[#EF4444]"></i>
              </div>
            </div>
            <p className="text-2xl font-bold text-[#0A2A43]">6</p>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-[#6B7280]">Críticas</span>
              <div className="w-8 h-8 rounded-lg bg-[#EF4444]/10 flex items-center justify-center">
                <i className="ri-error-warning-line text-[#EF4444]"></i>
              </div>
            </div>
            <p className="text-2xl font-bold text-[#EF4444]">2</p>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-[#6B7280]">Urgentes</span>
              <div className="w-8 h-8 rounded-lg bg-[#F59E0B]/10 flex items-center justify-center">
                <i className="ri-time-line text-[#F59E0B]"></i>
              </div>
            </div>
            <p className="text-2xl font-bold text-[#F59E0B]">2</p>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-[#6B7280]">Altas</span>
              <div className="w-8 h-8 rounded-lg bg-[#EAB308]/10 flex items-center justify-center">
                <i className="ri-alert-line text-[#EAB308]"></i>
              </div>
            </div>
            <p className="text-2xl font-bold text-[#EAB308]">2</p>
          </div>
        </div>

        {/* Filters */}
        <div className="bg-white rounded-lg border border-gray-200 p-4">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setSelectedFilter('todos')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                selectedFilter === 'todos'
                  ? 'bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white'
                  : 'bg-gray-100 text-[#6B7280] hover:bg-gray-200'
              }`}
            >
              Todos (6)
            </button>
            <button
              onClick={() => setSelectedFilter('criticas')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                selectedFilter === 'criticas'
                  ? 'bg-[#EF4444] text-white'
                  : 'bg-gray-100 text-[#6B7280] hover:bg-gray-200'
              }`}
            >
              Críticas (2)
            </button>
            <button
              onClick={() => setSelectedFilter('urgentes')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                selectedFilter === 'urgentes'
                  ? 'bg-[#F59E0B] text-white'
                  : 'bg-gray-100 text-[#6B7280] hover:bg-gray-200'
              }`}
            >
              Urgentes (2)
            </button>
            <button
              onClick={() => setSelectedFilter('documentos')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                selectedFilter === 'documentos'
                  ? 'bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white'
                  : 'bg-gray-100 text-[#6B7280] hover:bg-gray-200'
              }`}
            >
              Docs. Faltantes (2)
            </button>
            <button
              onClick={() => setSelectedFilter('vencidas')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                selectedFilter === 'vencidas'
                  ? 'bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white'
                  : 'bg-gray-100 text-[#6B7280] hover:bg-gray-200'
              }`}
            >
              Vencidas (1)
            </button>
          </div>
        </div>

        {/* Risk Operations Table */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Operación</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Cliente</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Tipo Riesgo</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Motivo</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Responsable</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Tiempo</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase">Prioridad</th>
                  <th className="px-4 py-3 text-right text-xs font-semibold text-[#6B7280] uppercase">Acciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {riskOperations.map((op) => (
                  <tr key={op.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-4">
                      <div className="flex items-center gap-2">
                        <div className={`w-8 h-8 rounded-lg ${getPriorityColor(op.prioridad)}/10 flex items-center justify-center`}>
                          <i className={`${getRiskIcon(op.riesgo)} text-sm`}></i>
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-[#0A2A43]">{op.correlativo}</p>
                          <p className="text-xs text-[#6B7280]">{op.tipo}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <p className="text-sm text-[#0A2A43]">{op.cliente}</p>
                    </td>
                    <td className="px-4 py-4">
                      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-[#EF4444]/10 text-[#EF4444]">
                        <i className={`${getRiskIcon(op.riesgo)}`}></i>
                        {op.riesgo}
                      </span>
                    </td>
                    <td className="px-4 py-4">
                      <p className="text-sm text-[#6B7280]">{op.motivo}</p>
                    </td>
                    <td className="px-4 py-4">
                      <p className="text-sm text-[#0A2A43]">{op.responsable}</p>
                    </td>
                    <td className="px-4 py-4">
                      <span className="text-sm font-semibold text-[#EF4444]">{op.tiempoVencido}</span>
                    </td>
                    <td className="px-4 py-4">
                      <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-semibold ${getPriorityColor(op.prioridad)}`}>
                        {op.prioridad.toUpperCase()}
                      </span>
                    </td>
                    <td className="px-4 py-4">
                      <div className="flex items-center justify-end gap-2">
                        <button
                          onClick={() => {
                            setSelectedOp(op);
                            setShowDetailModal(true);
                          }}
                          className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer"
                          title="Ver detalle"
                        >
                          <i className="ri-eye-line text-[#6B7280]"></i>
                        </button>
                        <button className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer" title="Notificar">
                          <i className="ri-notification-line text-[#6B7280]"></i>
                        </button>
                        <button className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer" title="Reasignar">
                          <i className="ri-user-shared-line text-[#6B7280]"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Detail Modal */}
      {showDetailModal && selectedOp && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className={`w-12 h-12 rounded-lg ${getPriorityColor(selectedOp.prioridad)}/10 flex items-center justify-center`}>
                  <i className={`${getRiskIcon(selectedOp.riesgo)} text-2xl`}></i>
                </div>
                <div>
                  <h2 className="text-xl font-bold text-[#0A2A43]">{selectedOp.correlativo}</h2>
                  <p className="text-sm text-[#6B7280]">{selectedOp.cliente}</p>
                </div>
              </div>
              <button onClick={() => setShowDetailModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6 space-y-6">
              <div className="bg-[#EF4444]/5 border border-[#EF4444]/20 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <i className="ri-error-warning-line text-[#EF4444] text-2xl mt-0.5"></i>
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-[#EF4444] mb-1">{selectedOp.riesgo}</p>
                    <p className="text-sm text-[#6B7280]">{selectedOp.motivo}</p>
                  </div>
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getPriorityColor(selectedOp.prioridad)}`}>
                    {selectedOp.prioridad.toUpperCase()}
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-[#6B7280] mb-1">Responsable Actual</label>
                  <p className="text-sm font-medium text-[#0A2A43]">{selectedOp.responsable}</p>
                </div>
                <div>
                  <label className="block text-xs font-medium text-[#6B7280] mb-1">Tiempo Vencido</label>
                  <p className="text-sm font-semibold text-[#EF4444]">{selectedOp.tiempoVencido}</p>
                </div>
                <div>
                  <label className="block text-xs font-medium text-[#6B7280] mb-1">Estado Actual</label>
                  <p className="text-sm font-medium text-[#0A2A43]">{selectedOp.estado}</p>
                </div>
                <div>
                  <label className="block text-xs font-medium text-[#6B7280] mb-1">Tipo Operación</label>
                  <p className="text-sm font-medium text-[#0A2A43]">{selectedOp.tipo}</p>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Acción Correctiva</label>
                <textarea rows={4} placeholder="Describe las acciones a tomar..." className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]"></textarea>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Reasignar a</label>
                <select className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  <option>Mantener responsable actual</option>
                  <option>Juan Delgado - Gerente Operaciones</option>
                  <option>María González - Coordinadora Aduanas</option>
                  <option>Carlos Ramírez - Especialista Importaciones</option>
                  <option>Ana Torres - Especialista Exportaciones</option>
                </select>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
              <button onClick={() => setShowDetailModal(false)} className="px-4 py-2.5 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                Cancelar
              </button>
              <button className="px-4 py-2.5 bg-[#F59E0B] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap">
                <i className="ri-notification-line mr-2"></i>Notificar
              </button>
              <button
                onClick={() => {
                  setShowDetailModal(false);
                  alert('Operación actualizada correctamente');
                }}
                className="px-4 py-2.5 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap"
              >
                <i className="ri-save-line mr-2"></i>Guardar Cambios
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
